
export class AdminGamerFilterList {
  constructor( obj ) {
    this.gamerList = obj?.map( s => ( {
      label: s.fullName.trim(),
      value: s.fullName === "N/A" ? " " : s.fullName.trim() } // Handle names which contain first and last name as empty
    ) );
  }
}
